"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fonts = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _typography = require("@vds-core/typography");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != (0, _typeof2["default"])(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
//****** To-do, test loading in the families first asynchronously from check whether to load the url if necessary ******//

var FontConfig = {
  loaded: false
};

//Turn on or off the font loader
function setFontLoaded(loaded) {
  FontConfig.loaded = loaded ? true : false;
  _typography.Fonts.setFontLoaded && _typography.Fonts.setFontLoaded(loaded);
}
function checkFontLoaded() {
  return FontConfig.loaded;
}

// Define and Load the fonts
var customConfig = {
  families: ["Verizon-NHG-eTX", "Verizon-NHG-eDS"]
};
var fontUri1 = "https://respframework.verizon.com/fonts/eText/verizon-nhg-etx-update.css";
var fontUri2 = "respframework.verizon.com/fonts/eText/verizon-nhg-etx.css";
function finishLoading(_x) {
  return _finishLoading.apply(this, arguments);
}
function _finishLoading() {
  _finishLoading = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(customConfig) {
    var WebFont, WebFontConfig;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("webfontloader"));
          });
        case 3:
          WebFont = _context.sent;
          WebFontConfig = {
            custom: customConfig,
            active: function active() {
              return setFontLoaded(true);
            },
            inactive: function inactive() {
              return console.warn("fonts could not be loaded.");
            }
          };
          WebFont.load(WebFontConfig);
          _context.next = 11;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          typeof window !== "undefined" && console.error(_context.t0);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _finishLoading.apply(this, arguments);
}
function checkIfLoaded() {
  if (typeof document === "undefined") return false;
  var links = Array.from(document.head.getElementsByTagName("link"));
  if (!links || !links.length) return false;
  return links.find(function (link) {
    return link.getAttribute("href") === fontUri1 || link.getAttribute("href") === fontUri2;
  });
}
function loadFonts() {
  var loaded = checkIfLoaded();
  if (!loaded) {
    customConfig.urls = [fontUri1];
    finishLoading(customConfig);
  } else setFontLoaded(true);
}
if (checkIfLoaded()) setFontLoaded(true);
if (!checkFontLoaded()) loadFonts();
var Fonts = exports.Fonts = {
  VerizonNHGeDS: "Verizon-NHG-eDS",
  // Display
  VerizonNHGeTX: "Verizon-NHG-eTX",
  // Text
  checkFontLoaded: checkFontLoaded,
  setFontLoaded: setFontLoaded,
  loadFonts: loadFonts
};


//////////////////
// WEBPACK FOOTER
// ./~/@vds/typography/dist/cjs/fonts/index.js
// module id = 167
// module chunks = 0